import { render, staticRenderFns } from "./ReminderListItem.vue?vue&type=template&id=7741e42a&scoped=true&"
import script from "./ReminderListItem.vue?vue&type=script&lang=js&"
export * from "./ReminderListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7741e42a",
  null
  
)

export default component.exports